import React from "react";
import { PressableOpacity, Box, MainText } from "app/components/common";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import CameraVideoIcon from "app/components/Icons/Video/CameraVideoIcon";
import MicroIcon from "app/scenes/MessageScreen/icon/MicroIcon";
import i18n from "@microdoing/shared/i18n";

interface Props {
  onClick: () => void;
  recordType: string;
}

const RecordAskPermission = ({ onClick, recordType = "camera" }: Props) => {
  return (
    <Box flex={1} alignItems="center" justifyContent="center">
      <PressableOpacity
        style={{
          width: normalize(110),
          height: normalize(110),
          borderRadius: normalize(55),
        }}
        onPress={onClick}
      >
        <Box
          width="100%"
          height="100%"
          borderRadius={normalize(55)}
          backgroundColor="brand.500"
          alignItems="center"
          justifyContent="center"
          marginBottom="xm"
        >
          {recordType === "camera" && (
            <CameraVideoIcon
              width={normalize(60)}
              height={normalize(60)}
              color={theme.colors["neutral.white"]}
            />
          )}
          {recordType === "audio" && (
            <MicroIcon
              width={normalize(60)}
              height={normalize(60)}
              color={theme.colors["neutral.white"]}
            />
          )}
        </Box>
      </PressableOpacity>
      <MainText
        marginTop="m"
        textAlign="center"
        variant="l4-medium"
        color="neutral.500"
      >
        {i18n.t("record-new-video")}
      </MainText>
    </Box>
  );
};

export default RecordAskPermission;
